import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Btn } from '../../AbstractElements';
import { AddPayment, AddPayments, Cancel, LogOut, Print, ThermalPrint, key, key_secret, share } from '../../Constant';
import { Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Spinner } from 'reactstrap';
import { useReactToPrint } from 'react-to-print';
import { useLocation, useNavigate } from 'react-router';
import Transparentspinner from "../Common/Loader/Transparentspinner";
import { changeCompanyRole, getCompany, getCompanyAgent, getCompanyRole, getGeneratePayment, getInvoice, getMakePayment, getPackageDet } from '../../CommonUrl';
import * as authServices from "../../Utils/authServices";
import { getMasterDataToken, postClientUrlWithToken, postDataWithoutResData, postMasterToken } from '../../Utils/restUtils';
import { toast } from 'react-toastify';
import NavSign from '../../Billerq/Sign/NavSign';
import AccountSuspended from '../InvoiceExternal/AccountSuspended';
import { useDispatch, useSelector } from 'react-redux';
import { setCompanyActiveStatus } from '../../Redux/Reducer';

const SuspendedPage = () => {
  const [loading, setloading] = useState(false)

  const navigate = useNavigate();
  const [company, setCompany] = useState('');
  const [importDrpodown, setimportDrpodown] = useState(false);

  const dispatch = useDispatch();

  const authState = useSelector((state) => state.auth);

  const toggleImport = () => setimportDrpodown(!importDrpodown);

  const companyData = async () => {
    const data = await postClientUrlWithToken(authState.apiUrl, getCompanyRole);
    if (data.status === 200) {
      const companyData = data.data.data;
      if (companyData.length > 0) {
        setCompany(companyData);
        const activeCompany = companyData.filter(item => item.status == 'active');
        if (activeCompany[0].subscription_status !== 'active') {
          dispatch(setCompanyActiveStatus('inactive'))
          navigate(`${process.env.PUBLIC_URL}/suspended`);
        }
      } else {
        setCompany("");
      }
    } else if (data.status >= 400 && data.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (data.status >= 500 && data.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
  };
  const companyChangeData = async (id, status) => {
    if (status !== 'active') {
      toast.error("Your account is suspended. Please contact support team.");
      return;
    }
    setloading(true);
    const data = await postClientUrlWithToken(authState.apiUrl, changeCompanyRole, { company_id: id });
    if (data.status === 200) {
      if (data.data.status === true) {
        dispatch(setCompanyActiveStatus('active'))
        window.location.href = `${process.env.PUBLIC_URL}/dashboard/default/`;
        const newActiveCompany = company.find(company => company.id === id);

        if (newActiveCompany) {
          toast.success(data.data.message)
          companyData();
        }
      } else {
        toast.error(data.data.message);
        setloading(false);
      }
    } else if (data.status >= 400 && data.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (data.status >= 500 && data.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
    setloading(false);
  };

  useEffect(() => {

    companyData()
  }, [])







  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <NavSign showProfile={true} buttonText={LogOut} />


      <div className='bg-light p-5' style={{ height: '100%' }}>
        <Card>
          <CardBody>
            <div style={{ display: 'flex', float: 'right' }}>
              <Dropdown className='ms-2' isOpen={importDrpodown} toggle={toggleImport}>
                <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                  Change Company <i className="icofont icofont-arrow-down"></i>
                </DropdownToggle>
                <DropdownMenu container="body">
                  {Array.isArray(company) && company.length > 0 ? (
                    company.map((item, index) => (
                      <DropdownItem key={index} onClick={() => companyChangeData(item.id, item.subscription_status)}>{item.name} <span style={{ fontSize: '8px' }} className={`${item.subscription_status === 'active' ? 'badge bg-success' : 'badge bg-danger'}`}>{item.subscription_status}</span></DropdownItem>
                    ))
                  ) : <p>Loading...</p>
                  }
                </DropdownMenu>
              </Dropdown>
            </div>
            <AccountSuspended />

          </CardBody>
        </Card>

      </div>
    </Fragment>
  );
};

export default SuspendedPage;